import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import {
  ACTIVE_ERROR_DESCRIPTION,
  ACTIVE_ERROR_TYPE,
  ActiveErrorData,
  ActiveErrorsStore,
  DevicesStore,
  GatewayStore,
  InstallationFeaturesStore,
} from '@store';

import {
  DeviceNameCommands,
  DeviceNameProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { CustomTranslationsService } from '../../../../../operational-data-common/translations';
import { PillType } from '../../../../../shared/components/pill/pill.model';
import { matTooltipSetter } from '../../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-maintenance-notification',
  templateUrl: './maintenance-notification.component.html',
  styleUrls: ['./maintenance-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceNotificationComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() maintenanceNotifications: ActiveErrorData[];

  readonly pillType = PillType;
  readonly ACTIVE_ERROR_TYPE = ACTIVE_ERROR_TYPE;
  readonly ACTIVE_ERROR_DESCRIPTION = ACTIVE_ERROR_DESCRIPTION;
  readonly featurePropertyKey = FeaturePropertyKey;

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    public devicesStore: DevicesStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    public gatewayStore: GatewayStore,
    protected customTranslationsService: CustomTranslationsService
  ) {}

  getDeviceNameFeature(
    deviceId: string
  ): Observable<Feature<DeviceNameProperties, DeviceNameCommands>> {
    return this.installationFeaturesStore.selectInstallationDeviceFeature<
      DeviceNameProperties,
      DeviceNameCommands
    >(FeatureNames.deviceName, deviceId);
  }
}
